import { render, staticRenderFns } from "./ComplaintAdd.vue?vue&type=template&id=2184b957&"
import script from "./ComplaintAdd.vue?vue&type=script&lang=js&"
export * from "./ComplaintAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports